<nz-layout>
  <nz-content>
    <ng-container>
      <app-reusable-table title="Past Care Teams" [columns]="[
          'Template',
          'Category',
          'Status',
          'Onset Date',
          'End Date'
        ]" [rowFields]="[
          'careTeamTemplateName',
          'careTeamCategoryDisplay',
          'careTeamStatusDisplay',
          'onSetDate',
          'endDate'
        ]" [data]="pastCareTeams" [isLoading]="isLoading" [expandComponent]="expandComp" [isPreview]="false"
        [isStopped]="true" [revertStopFun]="revertStopFun" [stopPermissions]="['s-ct']"
        [revertStopTooltip]="'Undo Unassign Care Team'" />
    </ng-container>
  </nz-content>
</nz-layout>
